import { SpendTransactionFix } from "graphql/generated";
import { SnapRadioButton } from "suit";

type Step2GroupSelectProps = {
  groupsAffected?: {
    keys: string[];
    result: Record<string, SpendTransactionFix[]>;
  };
  selectedGroup?: { id: string; name: string };
  setSelectedGroup: React.Dispatch<
    React.SetStateAction<{ id: string; name: string } | undefined>
  >;
};

function Step2GroupSelect({
  groupsAffected,
  selectedGroup,
  setSelectedGroup,
}: Step2GroupSelectProps) {
  return (
    <>
      <p>Select a group</p>
      {groupsAffected?.keys.map((g) => {
        return (
          <div
            key={g}
            className="flex border mt-4 p-4 rounded-lg cursor-pointer"
            onClick={() => {
              setSelectedGroup({
                id: g,
                name: groupsAffected.result[g].at(0)?.groupName ?? "",
              });
            }}
          >
            <div className="flex items-center ">
              <SnapRadioButton checked={selectedGroup?.id === g} />
              <p>{groupsAffected.result[g].at(0)?.groupName}</p>
            </div>
            <p className="ml-auto">({groupsAffected.result[g].length})</p>
          </div>
        );
      })}
    </>
  );
}

export default Step2GroupSelect;
